export default {
  'stripe': ['stripe-hosted-fields'],
  'braintree': ['braintree-hosted-fields', 'braintree-paypal'],
  'windcave': ['windcave-hosted-fields'],
};
